import React from 'react'

import { type ComponentType } from '../types/dashboard'

import { classNames } from '~/utils/classNames'

import AutoRenewingLicensesTile from './tiles/AutoRenewingLicensesTile'
import AwaitingActionTicketsTile from './tiles/AwaitingActionTicketsTile'
import AwaitingResponseTicketsTile from './tiles/AwaitingResponseTicketsTile'
import AzureMonthToDateTile from './tiles/AzureMonthToDateTile'
import Azure from './tiles/AzureTile'
import AzureTotalEmissionsTile from './tiles/AzureTotalEmissionsTile'
import AzureYearToDateTile from './tiles/AzureYearToDateTile'
import ClosedTicketsTile from './tiles/ClosedTicketsTile'
import CompletedChangesTile from './tiles/CompletedChangesTile'
import ExpiringLicensesTile from './tiles/ExpiringLicensesTile'
import KeyContactsTile from './tiles/KeyContactsTile'
import MajorIncidentsTile from './tiles/MajorIncidentsTile'
import OpenTicketsTile from './tiles/OpenTicketsTile'
import QuickActionsTile from './tiles/QuickActionsTile'
import QuickLinksTile from './tiles/QuickLinksTile'
import RecentAzureDeploymentsTile from './tiles/RecentAzureDeploymentsTile'
import RecentFilesTile from './tiles/RecentFilesTile'
import SecureScoresTile from './tiles/SecureScoresTile'
import TicketsByPriorityTile from './tiles/TicketsByPriorityTile'
import TicketsByStatusTile from './tiles/TicketsByStatusTile'
import UpcomingChangesTile from './tiles/UpcomingChangesTile'

interface Props {
  componentType: ComponentType
  slotId: string
  isConfigurable?: boolean
}

export const DashboardComponent: React.FC<Props> = ({ componentType, slotId, isConfigurable }) => {
  const renderComponent = () => {
    switch (componentType) {
      case 'secureScores':
        return <SecureScoresTile />
      case 'azure':
        return <Azure />
      case 'keyContacts':
        return <KeyContactsTile />
      case 'expiringLicenses':
        return <ExpiringLicensesTile />
      case 'autoRenewingLicenses':
        return <AutoRenewingLicensesTile />
      case 'awaitingActionTickets':
        return <AwaitingActionTicketsTile />
      case 'closedTickets':
        return <ClosedTicketsTile />
      case 'awaitingResponseTickets':
        return <AwaitingResponseTicketsTile />
      case 'openTickets':
        return <OpenTicketsTile />
      case 'recentFiles':
        return <RecentFilesTile />
      case 'ticketsByPriority':
        return <TicketsByPriorityTile />
      case 'ticketsByStatus':
        return <TicketsByStatusTile />
      case 'azureTotalEmissions':
        return <AzureTotalEmissionsTile />
      case 'recentAzureDeployments':
        return <RecentAzureDeploymentsTile />
      case 'quickLinks':
        return <QuickLinksTile />
      case 'quickActions':
        return <QuickActionsTile />
      case 'completedChanges':
        return <CompletedChangesTile />
      case 'upcomingChanges':
        return <UpcomingChangesTile />
      case 'azureYearToDate':
        return <AzureYearToDateTile />
      case 'azureMonthToDate':
        return <AzureMonthToDateTile />
      case 'majorIncidents':
        return <MajorIncidentsTile />
      default:
        return null
    }
  }

  return (
    <div
      data-swapy-slot={slotId}
      key={slotId + '_slot'}
      className={classNames('rounded-xl data-[swapy-highlighted]:outline data-[swapy-highlighted]:outline-2 data-[swapy-highlighted]:outline-th-primary')}
    >
      <div
        data-swapy-item={componentType}
        key={componentType}
        className={classNames(
          'h-full overflow-hidden rounded-xl border bg-th-content data-[swapy-dragging]:!z-[900] data-[swapy-dragging]:!opacity-90',
          isConfigurable ? 'cursor-move border-th-content-secondary hover:border-th-border [&>*]:pointer-events-none [&>*]:select-none' : 'border-th-border'
        )}
      >
        {renderComponent()}
      </div>
    </div>
  )
}
